import { getUrlWithoutQueryOrHash, getRegisteredDomain, urlToURL } from '../utils/domains';

export const CallStackResolutions = [
	'registered-domain',
	'origin',
	'file',
	'url',
	'frame',
] as const;

export const CallStackResolutionExamples = {
	'frame': 'b.a.com/?x=y:3:7',
	'url': 'b.a.com/u?x=y',
	'file': 'b.a.com/u',
	'origin': 'b.a.com',
	'registered-domain': 'a.com',
 } satisfies Record<CallStackResolution, string>;

export type CallStackResolution = (typeof CallStackResolutions[number]);
export interface HasCallStackResolution {
	callStackResolution: CallStackResolution | undefined;
}
export const CallStackResolutionDefault: CallStackResolution = 'origin';

export interface CallFrameLike {
	url?: string;
	lineNumber?: number;
	columnNumber?: number;
}

export type CallFrameToString = (f: CallFrameLike) => string | undefined;

export const callFrameToStringFn = (callStackResolution: CallStackResolution): CallFrameToString =>
	callStackResolution === 'url' ?
		(f) => f.url :
	callStackResolution === 'file' ?
		(f) => f.url == null ? undefined : getUrlWithoutQueryOrHash(f.url) :
	callStackResolution === 'registered-domain' ?
		(f) => getRegisteredDomain(f.url) :
	callStackResolution === 'origin' ?
		(f) => urlToURL(f.url)?.origin :
	callStackResolution === 'frame' ?
		(f) => f.url == null ? undefined : `${f.url}:${f.lineNumber ?? ''}:${f.columnNumber ?? ''}` :
		(() => { throw new Error(`Unknown call stack format: ${callStackResolution}`); })();

export const callFramesEqualFn = (callStackResolution: CallStackResolution) => {
	const callFrameToString = callFrameToStringFn(callStackResolution);
	return (a: CallFrameLike, b: CallFrameLike) => {
		const aString = callFrameToString(a);
		const bString = callFrameToString(b);
		return aString === bString;
	}
}

